module.exports = __webpack_public_path__ + "img/menu-hide.5d1f1f71.svg";